// extracted by mini-css-extract-plugin
export default {"root":"BottomNav_root__eyvqX","item":"BottomNav_item__Booja","on":"BottomNav_on__afd2T"};